import API from "./axios";

export const loginUser = (data) => API.post("/auth/login", data);
export const registerUser = (data) => API.post("/auth/register", data);
export const forgetPassword = (data) =>  API.post("/auth/forgot-password", data);
export const changePassword = (data) =>  API.post("/auth/change-password", data);